import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-6 row justify-start items-center content-center" }
const _hoisted_2 = {
  key: 0,
  class: "col-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    class: _normalizeClass(["s-notification--header row justify-between", _ctx.isMobile && 'column'])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["s-notification--title col-auto", _ctx.isMobile ? 'col-10' : _ctx.isLaptop ? 'col-10' : 'col-6'])
        }, " Уведомления ", 2),
        (_ctx.countNotifications > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.isMobile ? 'col-2' : _ctx.isLaptop ? 'col-2' : 'col-2')
            }, [
              _createVNode(_component_q_badge, {
                class: "s-badge s-badge--mini hovered",
                outline: "",
                color: "brand"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.countNotifications) + " ", 1),
                  _createVNode(_component_q_tooltip, { "content-class": "s-tooltip" }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode(" Количество непрочитанных уведомлений ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["col-6 row justify-between items-center content-center text-right", _ctx.isMobile ? 'justify-start s-mt-lg' : 'justify-end'])
      }, [
        (_ctx.haveUnreadNotifications)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: "s-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.notificationsReaded && _ctx.notificationsReaded(...args)))
              }, [
                _cache[3] || (_cache[3] = _createTextVNode(" Прочитать все ")),
                _createVNode(_component_q_tooltip, { "content-class": "s-tooltip" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Отметь все непрочитанные уведомления, как прочитанные ")
                  ])),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["text-right", { 'col-3': _ctx.haveUnreadNotifications, 'col-12': !_ctx.haveUnreadNotifications }])
        }, [
          _createVNode(_component_s_icon, {
            name: "app:close",
            onClick: _ctx.changeVisibilityNotificationModal
          }, null, 8, ["onClick"])
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}